import { Accordion, AccordionTab } from "primereact/accordion";

import DwellingDetailBadgesComponent from "./DwellingDetailBadgesComponent";
import HouseIcon from "../../../assets/svg/house-icon.svg";

interface AccordionDwellingProps {
  info: any;
  dwellingAddress: string;
}

const AccordionDwelling: React.FC<AccordionDwellingProps> = ({
  info,
  dwellingAddress,
}) => {
  const customExpandIcon = () => (
    <div className="custom-icon custom-icon--closed">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="9"
        viewBox="0 0 16 9"
        fill="none"
      >
        <path
          d="M1 8L7.29289 1.70711C7.68342 1.31658 8.31658 1.31658 8.70711 1.70711L15 8"
          stroke="#000D5B"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );

  const customCollapseIcon = () => (
    <div className="custom-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="9"
        viewBox="0 0 16 9"
        fill="none"
      >
        <path
          d="M1 8L7.29289 1.70711C7.68342 1.31658 8.31658 1.31658 8.70711 1.70711L15 8"
          stroke="#000D5B"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );

  const headerPreview = (
    <div className="d-flex align-items-center">
      <img src={HouseIcon} alt="Icone de maison" />
      <p className="mb-0 ms-3">Aperçu du bien</p>
    </div>
  );

  return (
    <Accordion
      activeIndex={[0, 1]}
      multiple
      className="custom-accordion"
      expandIcon={customExpandIcon}
      collapseIcon={customCollapseIcon}
    >
      <AccordionTab header={headerPreview}>
        <div className="d-flex justify-content-between mb-2">
          <p className="m-0 text-12">{dwellingAddress}</p>
          <p>N° {info && info.managementLotNumber}</p>
        </div>
        {<DwellingDetailBadgesComponent dwelling={info} viewMore={false} />}
        {info?.address?.address?.residenceName && (
          <p className="mt-3 ">
            Nom de la résidence : {info.address.address.residenceName}
          </p>
        )}
        {info?.address?.address?.digicode && (
          <p>Digicode : {info.address.address.digicode}</p>
        )}
        {info?.address?.address?.addiitionnalAddress && (
          <p className="">
            Bâtiment : {info.address.address.addiitionnalAddress}
          </p>
        )}
        {info?.constructionPeriod?.label && (
          <p className="mt-4">
            Période de construction :
            {info?.constructionPeriod.label.substring(
              info.constructionPeriod.label.indexOf("<") + 1,
            )}
          </p>
        )}
        {info?.condominiumNumber && (
          <p>Copropriété : oui - {info.condominiumNumber}</p>
        )}
        <div className="d-flex">
          {info?.address?.cellarNumber && (
            <p className="mt-4 me-5">Cave : {info.address.cellarNumber}</p>
          )}
          {info?.address?.garageBoxNumber && (
            <p className="mt-4 me-5">Garage : {info.address.garageBoxNumber}</p>
          )}
          {info?.address?.indoorParkingNumber && (
            <p className="mt-4">Parking : {info.address.indoorParkingNumber}</p>
          )}
        </div>
      </AccordionTab>
      <AccordionTab header="Informations bailleur :">
        <div className="custom-accordion__info">
          <p>Nom de l'agence - Nom du gestionnaire</p>
          {info?.datedReference && (
            <p> N° de lot de gestion : {info.datedReference}</p>
          )}
          <p className="mt-3">Du lundi au samedi {info.agencelabel}</p>
          <p>De 9h à 12 - 14h à 18h30 {info.agencelabel}</p>
          {info?.agency?.address?.address && (
            <p className="mt-3 mb-0 custom-accordion__address">
              {info.agency.address.address}, {info.agency.address.zip}{" "}
              {info.agency.address.city}
            </p>
          )}
        </div>
      </AccordionTab>
    </Accordion>
  );
};

export default AccordionDwelling;
